import { render, staticRenderFns } from "./PageSubTitle.vue?vue&type=template&id=6f7b1348"
import script from "./PageSubTitle.vue?vue&type=script&lang=js"
export * from "./PageSubTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports